<!-- A hidden div is created to set the position of appearance of the menu-->
<div
  class="context-menu-trigger"
  [ngStyle]="menuRootStyle"
  [matMenuTriggerFor]="actionMenu"
></div>
<mat-menu #actionMenu="matMenu" (closed)="onMenuClosed()">
  @if (!hideOpen) {
    <button mat-menu-item (click)="onClickOpenDocuments()">
      <span transloco="OPEN_DOCUMENTS"></span>
    </button>
  }
  @if (!hideOpenFullViewer()) {
    <button mat-menu-item (click)="onClickOpenDocuments(true)">
      <span transloco="OPEN_IN_FULL_VIEWER"></span>
    </button>
  }
  @if (hasCopyValue()) {
    <mat-divider></mat-divider>
    <button mat-menu-item (click)="copyToClipboard()">
      <span transloco="COPY_VALUE"></span>
    </button>
  }
  @if (showUserActions) {
    @if (!hideOpen || !hideOpenFullViewer) {
      <mat-divider></mat-divider>
    }
    @for (userAction of userActions; track userAction) {
      <button mat-menu-item (click)="onClickUserAction(userAction)">
        <mat-icon>call_split</mat-icon>
        {{ userAction.name }}
      </button>
    }
  }
  <mat-divider></mat-divider>
  @if (showUpdate) {
    <button
      mat-menu-item
      [disabled]="updateDisabled"
      (click)="onClickUpdateSelected()"
    >
      <span transloco="UPDATE"></span>
    </button>
  }
  <button mat-menu-item (click)="onClickCopy()">
    <span transloco="COPY"></span>
  </button>
</mat-menu>
